import React from "react";

const MAP = {
  pending_payment: { label: "Awaiting Payment", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  paid: { label: "Paid", cls: "bg-blue-100 text-blue-800 border-blue-200" },
  assigned: { label: "Ready for pickup", cls: "bg-indigo-100 text-indigo-800 border-indigo-200" },
  picked_up: { label: "On Board", cls: "bg-purple-100 text-purple-800 border-purple-200" },
  in_transit: { label: "In Transit", cls: "bg-cyan-100 text-cyan-800 border-cyan-200" },
  confirmed: { label: "Confirmed (Account)", cls: "bg-teal-100 text-teal-800 border-teal-200" },
  delivered: { label: "Delivered", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  onforwarded: { label: "On-forwarded · Manual Tracking", cls: "bg-orange-100 text-orange-800 border-orange-200" },
  cancelled: { label: "Cancelled", cls: "bg-red-100 text-red-800 border-red-200" },
};

export default function StatusBadge({ status, testid }) {
  const s = MAP[status] || { label: status, cls: "bg-gray-100 text-gray-700 border-gray-200" };
  return (
    <span
      data-testid={testid || `status-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.cls}`}
    >
      {s.label}
    </span>
  );
}
